import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { ENV, LOG_TYPE } from '../const/logger.const';
/**
 * Logger
 * @class
 */
class Logger {
    /**
     * Universal Logger method
     * @param value `any`. Text to display in the console
     * @param type `LOG_TYPE`, default: `info`(green). Also available: `error`(red) and `warning`(yellow)
     */
    message(value, type = LOG_TYPE.info, env = process.env.NODE_ENV) {
        const isPrimitive = !isObject(value) && !isArray(value);
        const skippedEnvs = [ENV.prod, ENV.test, ENV.production];
        if (!includes(skippedEnvs, env)) {
            if (isPrimitive) {
                console.info(`%c ${value}`, this.getMessageColour(type));
            }
            else {
                console.table ? console.table(value) : console.info(value);
            }
        }
    }
    /**
     * Evaluates the type(colour) of message to present
     * @param text `string`
     * @param type `LOG_TYPE`
     * @private
     */
    getMessageColour(type = LOG_TYPE.info) {
        switch (type) {
            case LOG_TYPE.error:
                return 'background: #DC143C; color: #fff';
            case LOG_TYPE.warning:
                return 'background: #FFFF33; color: #000';
            case LOG_TYPE.info:
            default:
                return 'background: #228B22; color: #fff';
        }
    }
}
/**
 * Logger Class Instance
 * @namespace
 */
export const logger = new Logger();
